module.exports = __webpack_public_path__ + "img/Mehrzweckarbeitsboot.a4e33883.svg";